module.exports = __webpack_public_path__ + "static/media/20.cfb3333c.webp";